module.exports = __webpack_public_path__ + "data/role.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/roles/role.json
// module id = pB1T
// module chunks = 1